import { render, staticRenderFns } from "./ProductIcon.vue?vue&type=template&id=6d763d83&"
import script from "./ProductIcon.vue?vue&type=script&lang=ts&"
export * from "./ProductIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports